<template>
  <div class="waterfall-chart-container">
    <div class="chart-header">
      <h3>媒体別採用プロセス ウォーターフォールチャート</h3>
    </div>
    <div class="chart-wrapper">
      <canvas ref="chartCanvas"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: 'MediaWaterfallChart',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.createChart()
  },
  watch: {
    data: {
      handler() {
        this.updateChart()
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy()
    }
  },
  methods: {
    createChart() {
      const ctx = this.$refs.chartCanvas.getContext('2d')
      this.chart = new Chart(ctx, {
        type: 'bar',
        data: this.formatChartData(),
        options: this.getChartOptions()
      })
    },
    
    updateChart() {
      if (this.chart) {
        this.chart.data = this.formatChartData()
        this.chart.update()
      }
    },
    
    formatChartData() {
      const labels = this.data.map(media => media.media_name)
      
      const datasets = [
        {
          label: '応募数',
          data: this.data.map(media => media.application_count),
          backgroundColor: '#3498db',
          borderColor: '#2980b9',
          borderWidth: 1
        },
        {
          label: '面接実施数',
          data: this.data.map(media => media.interview_count),
          backgroundColor: '#2ecc71',
          borderColor: '#27ae60',
          borderWidth: 1
        },
        {
          label: '採用数',
          data: this.data.map(media => media.hired_count),
          backgroundColor: '#e74c3c',
          borderColor: '#c0392b',
          borderWidth: 1
        }
      ]
      
      return {
        labels,
        datasets
      }
    },
    
    getChartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: false
          },
          legend: {
            position: 'bottom',
            labels: {
              padding: 15,
              font: {
                size: 12
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                let label = context.dataset.label || ''
                if (label) {
                  label += ': '
                }
                label += context.parsed.y + '人'
                
                // 応募数からの転換率を表示
                if (context.datasetIndex > 0) {
                  const applicationCount = context.chart.data.datasets[0].data[context.dataIndex]
                  if (applicationCount > 0) {
                    const rate = ((context.parsed.y / applicationCount) * 100).toFixed(1)
                    label += ` (${rate}%)`
                  }
                }
                
                return label
              }
            }
          }
        },
        scales: {
          x: {
            grid: {
              display: false
            },
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              minRotation: 45
            }
          },
          y: {
            beginAtZero: true,
            grid: {
              borderDash: [2, 2]
            },
            ticks: {
              callback: function(value) {
                return value + '人'
              }
            }
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.waterfall-chart-container {
  margin-top: 30px;
  background-color: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.chart-header {
  margin-bottom: 20px;
}

.chart-header h3 {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin: 0;
}

.chart-wrapper {
  position: relative;
  height: 400px;
  width: 100%;
}

@media (max-width: 768px) {
  .chart-wrapper {
    height: 300px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/DashBoard/Report/MediaAnalysis/MediaWaterfallChart.vue